export class RegisterJourneyEnum {
    constructor(_displayValue, _matchedStrings) {
        this.displayValue = _displayValue;
        this.matchedStrings = _matchedStrings;
    }
    // public static readonly UNKNOWN = new RegisterJourneyEnum('unknown', ['none-above'])
    static parseEnum(data) {
        let value = this.TOP_NAV;
        Object.values(RegisterJourneyEnum).forEach((a) => {
            var _a;
            if ((_a = a.matchedStrings) === null || _a === void 0 ? void 0 : _a.some((b) => data.lastIndexOf(b) > -1)) {
                value = a;
            }
        });
        return value;
    }
}
RegisterJourneyEnum.POLA = new RegisterJourneyEnum('pola', ['selling', 'autotrader.co.uk']);
RegisterJourneyEnum.REVIEWS = new RegisterJourneyEnum('reviews', ['car-reviews']);
RegisterJourneyEnum.COMPETITION = new RegisterJourneyEnum('competition', ['competition']);
RegisterJourneyEnum.VEHICLE_CHECK = new RegisterJourneyEnum('vehicle_check', ['www.vehiclecheck.co.uk']);
RegisterJourneyEnum.SAVE_SEARCH = new RegisterJourneyEnum('save_search', ['savesearch']);
RegisterJourneyEnum.SAVE_ADVERT = new RegisterJourneyEnum('save_advert', ['advertSaved']);
RegisterJourneyEnum.MY_AUTO_TRADER = new RegisterJourneyEnum('my_auto_trader', ['my-auto-trader']);
RegisterJourneyEnum.VALUATIONS = new RegisterJourneyEnum('valuations', ['car-valuation']);
RegisterJourneyEnum.TOP_NAV = new RegisterJourneyEnum('top-nav', ['top-nav']);
RegisterJourneyEnum.FPA = new RegisterJourneyEnum('fpa', ['classified/advert']);
RegisterJourneyEnum.CONTENT_NAV = new RegisterJourneyEnum('content-nav', ['content']);
RegisterJourneyEnum.MY_CAR = new RegisterJourneyEnum('my-car', ['my-car']);
RegisterJourneyEnum.MY_ADVERTS = new RegisterJourneyEnum('my-adverts', ['my-adverts-selector']);
RegisterJourneyEnum.MOTORHOMES = new RegisterJourneyEnum('motorhome', ['motorhome']);
RegisterJourneyEnum.CARAVANS = new RegisterJourneyEnum('caravan', ['caravan']);
RegisterJourneyEnum.BIKES = new RegisterJourneyEnum('bike', ['bikes']);
RegisterJourneyEnum.PLANT = new RegisterJourneyEnum('plant', ['plant']);
RegisterJourneyEnum.FARM = new RegisterJourneyEnum('farm', ['farm']);
RegisterJourneyEnum.VANS = new RegisterJourneyEnum('van', ['vans']);
RegisterJourneyEnum.TRUCKS = new RegisterJourneyEnum('truck', ['trucks']);
RegisterJourneyEnum.SEARCH = new RegisterJourneyEnum('search', ['search']);
